import React from 'react';
import PropTypes from 'prop-types';
import styled, { ThemeProvider } from 'styled-components';
import commonProps from './common/common-props';
import LivewireBrand from './common/livewire-brand';
import Form from './forgot-password-elements/form';
import RecoveryEmailSentConfirmation from './forgot-password-elements/recovery-email-sent-confirmation';
import PasswordRecoveryContext, { reducer, defaultState } from './forgot-password-elements/context';

const Page = styled.div`
  width: 100vw;
  display: flex;
  ${props => (
    props.theme.isMobile ? `
      flex-direction: column-reverse;
      align-items: center;
      background: ${props.theme.linearGradientDarkThemeRect}
    ` : 'flex-direction: row')};
`;

export default function ForgotPassword(props) {
  const common = commonProps();
  const [st, dispatch] = React.useReducer(reducer, defaultState);
  const state = {
    ...st,
    ...props,
    ...common,
  };
  const { email } = state;

  return (
    <ThemeProvider theme={state}>
      <PasswordRecoveryContext.Provider value={{ state, dispatch }}>
        <Page>
          <LivewireBrand />
          { !email ? <Form /> : <RecoveryEmailSentConfirmation /> }
        </Page>
      </PasswordRecoveryContext.Provider>
    </ThemeProvider>
  );
}

/* eslint-disable react/no-unused-prop-types */
ForgotPassword.propTypes = {
  logo: PropTypes.string.isRequired,
};
/* eslint-enable react/no-unused-prop-types */
